// Copyright (c) StrangeBee 2024

import { Switch } from 'antd';
import React, { ReactElement } from 'react';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';

import './ManageSwitch.scss';

export interface ManageSwitchProps {
    label: string;
    value: boolean;
    icon?: ReactElement;
    onChange: (b: boolean) => void;
}

export const ManageSwitch = ({ label, value, onChange, icon }: ManageSwitchProps): ReactElement => {
    return (
        <THTooltip title={label}>
            <div className="manage-switch" data-testid={label}>
                <Switch checked={value} onClick={onChange} checkedChildren={icon} unCheckedChildren={icon} />
            </div>
        </THTooltip>
    );
};
